import Swal from 'sweetalert2';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MessageService {

  private toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    backdrop: false,

    customClass: {
      popup: 'app-toast',
      title: 'app-toast-title',
      icon: 'app-toast-icon'
    },

    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });

  succmessage(message: string) {
    this.toast.fire({
      icon: 'success',
      title: message
    });
  }

  errmessage(message: string) {
    this.toast.fire({
      icon: 'error',
      title: message
    });
  }

  warning(message: string) {
    this.toast.fire({
      icon: 'warning',
      title: message
    });
  }

  info(message: string) {
    this.toast.fire({
      icon: 'info',
      title: message
    });
  }
}// import { Injectable } from "@angular/core";
// import { Router } from "@angular/router";
// import { ToastrService } from "ngx-toastr";

// @Injectable()
// export class MessageService {
//   constructor(
//     private toastr: ToastrService,
//     public router: Router,
//   ) { }

//   errmessage(err: any) {
//     if (err != '')
//       this.toastr.error(err);
//   }

//   succmessage(msg: any) {
//     if (msg != '')
//       this.toastr.success(msg);
//   }

//   messages(msg: any) {
//     // this._snackBar.open(msg, "", {
//     //   duration: 2000,
//     //   panelClass: [css],
//     // });
//     console.log(msg);

//   }

//   dissuccmessage(msg: any) {
//     const css = "green-snackbar";
//     this.dismissMessages(msg, css);
//   }

//   disserrmessage(msg: any) {
//     const css = "red-snackbar";
//     this.dismissMessages(msg, css);
//   }

//   dismissMessages(msg: any, css: any) {
//     // this._snackBar.open(msg, "X", {
//     //   panelClass: [css],
//     // });
//   }
// }
